import {Drawer, Select, Radio, Progress, Alert, Space, Spin} from "antd";
import FakeTable from "../../components/FakeTable";
import React, {useEffect, useState, useCallback, useMemo} from "react";
import _ from "lodash";
import {callWithCatch, pp} from "../../utils";
import NiceModal, {useModal, antdDrawer} from "@ebay/nice-modal-react";
import Device from "../../components/Device";
import {Switch2} from "../../components/Switcher";

let WinLosBar = ({percent, range}) => {
  let win = Math.max(0, percent-50)/range*100;
  let lose = Math.max(0, 50-percent)/range*100;

  let deviceFontSize = Device.xs ? "10px" : "11px"

  return <div className="grid grid-cols-5 gap-1">
    <div style={{transform: "scaleX(-1)"}} className="col-span-2">
      <Progress percent={lose} showInfo={false} strokeColor="#f87171"/>
    </div>
    <div className="col-span-2">
      <Progress percent={win} showInfo={false} strokeColor="#34d399"/>
    </div>
    <div className="pt-1" style={{fontSize: deviceFontSize, width: "80px"}}>
      {percent}%
    </div>
  </div>
}

export let ASPlayerStat = ({data, viz, onChange}) => {
  let headers = ['Players', "M#", "PW %"];

  let range = rangeCalc([data]);

  return <FakeTable cs="ant-table-small" objs={data.players} headers={headers}
                    tr={pd => {
                      let name = pd.name;
                      let nameStyle = {width: "200px"};

                      if (Device.xs)
                        nameStyle = {width: "120px", fontSize: "14px"};

                      // let nameTd = <td style={nameStyle}>{!Device.xs && <span className="text-slate-500">{pd.prefix}</span>} <a onClick={() => onChange(pd.id)}>{name}</a></td>
                      let nameTd = <td style={nameStyle}>{!Device.xs && <span className="text-slate-500">{pd.prefix}</span>} <span>{name}</span></td>
                      // if (overall)
                      //   nameTd = <td style={nameStyle}>{name}</td>;
                      return <>
                          {nameTd}
                          <td>{pd.mc || null}</td>
                          <td>
                            <WinLosBar percent={pd.pwp} range={range}/>
                          </td>
                        </>
                    }}
  />
}

let PlayerStat = ({data, viz, range, onChange}) => {
  let headers = [data.title, "GW", "GL", "PW", "PL", "PW %"];

  let overall = data.title === "Overall"

  viz = viz && !overall;

  if (viz)
    headers = [data.title, "Point Win %"];

  return <FakeTable cs="ant-table-small" objs={data.players} headers={headers}
                    tr={pd => {
                      let name = pd.name;
                      let nameStyle = {width: "200px"};

                      if (Device.xs)
                        nameStyle = {width: "120px", fontSize: "14px"};

                      let nameTd = <td style={nameStyle}>{!Device.xs && <span className="text-slate-500">{pd.prefix}</span>} <a onClick={() => onChange(pd.id)}>{name}</a></td>
                      if (overall)
                        nameTd = <td style={nameStyle}>{name}</td>;

                      if (viz)
                        return <>
                        {nameTd}
                          <td>
                            <WinLosBar percent={pd.pwp} range={range}/>
                          </td>
                        </>

                      return <>
                        {nameTd}
                        <td>{pd.gw}</td>
                        <td>{pd.gl}</td>
                        <td>{pd.pw}</td>
                        <td>{pd.pl}</td>
                        <td>{pd.pwp}%</td>
                      </>
                    }}
  />
}

export let rangeCalc = (stats) => {
  let pds = _.flatMap(stats, 'players');
  let nums = pds.map(pd => pd.pwp)

  let max = Math.max(...nums);
  let min = Math.min(...nums);

  return Math.min(Math.max(max-50, 50-min), 20);
};

export let Stats = ({ d, player_id, onChange: onPlayerChange, stickyControls = false, onControlsReady }) => {
  const [selected, setSelected] = useState(player_id || 0);
  const [stats, setStats] = useState();
  const [viz, setViz] = useState('viz');

  const players = useMemo(() => {
    if (!d?.teams) return [];
    const teams = _.filter(d.teams, 'confirmed');
    return _.sortBy(_.flatMap(teams, 'players'), 'name');
  }, [d?.teams]);

  const onChange = useCallback(async (v) => {
    setSelected(v);
    onPlayerChange?.(v);
    if (v)
      await callWithCatch({
        url: `/tournaments/${gon.tournament.tid}/players/${v}/stats`,
        method: 'get',
        onSuccess: data => {
          setStats(data)
        }
      })
    else
      await callWithCatch({
        url: `/divisions/${d?.id}/players_stats`,
        method: 'get',
        onSuccess: data => {
          setStats(data)
        }
      })
  }, [d?.id, onPlayerChange]);

  useEffect(() => {
    onChange(player_id);
  }, [onChange, player_id, d?.id])

  const vizSwitch = useMemo(() => <Radio.Group
    options={[{ label: "Overview", value: 'viz' }, { label: 'Details', value: 'details' }]}
    onChange={e => setViz(e.target.value)}
    value={viz}
    size={Device.xs ? "small" : "default"}
    optionType="button"
    buttonStyle="solid"
  />, [viz]);

  const range = useMemo(() => stats && rangeCalc(stats.stats), [stats]);

  const options = useMemo(() => {
    const opts = players.map(pl => ({label: pl.name, value: pl.id}));
    opts.unshift({label: "All Players", value: 0});
    return opts;
  }, [players]);

  const controls = useMemo(() => <div className="space-y-4">
    <div>
      <Space>
        { d && <Select
          showSearch
          autoFocus={!Device.xs}
          size={Device.xs ? "small" : "default"}
          value={selected}
          style={{width: "180px"}}
          placeholder="Select a Player"
          optionFilterProp="children"
          onChange={onChange}
          filterOption={(input, option) =>
            (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
          }
          options={options} /> }
        {vizSwitch}
      </Space>
    </div>
  </div>, [d, selected, onChange, options, vizSwitch]);

  useEffect(() => {
    onControlsReady?.(controls);
  }, [onControlsReady, controls]);

  let content = <>
    { !stats && <Spin />}
    { stats && <div>
      <div className="text-lg p-4 md:p-0 md:pb-8">
        {stats.name}
      </div>
      <Switch2 v={!!stats.stats[0].players.length}>
        <div className="space-y-8">
          {stats.stats.map(g => <PlayerStat onChange={onChange} key={g.title} data={g} viz={viz === 'viz'} range={range}/>)}
        </div>
        <Alert type="warning" message="Waiting For Results"/>
      </Switch2>
    </div>}
  </>

  if (onControlsReady) {
    return content;
  }

  if (stickyControls) {
    return <>
      <div className="sticky top-0 bg-white z-10 p-4 border-b">
        {controls}
      </div>
      <div className="p-4">
        {content}
      </div>
    </>
  }

  return <>
    {controls}
    {content}
  </>
}

let StatsDrawer = NiceModal.create(({ d, player_id }) => {
  const modal = useModal();
  const [drawerTitle, setDrawerTitle] = useState(null);

  return <Drawer footer={null}
                 title={drawerTitle}
                 bodyStyle={Device.xs ? { padding: 0, overflowX: 'hidden'} : {overflowX: 'hidden'}}
                 width={!Device.xs && 500} autoFocus={false}
    {...antdDrawer(modal)}
    >
    <Stats d={d} 
           player_id={player_id} 
           onControlsReady={setDrawerTitle} />
  </Drawer>
});

export const openStats = (d, player_id) => NiceModal.show(StatsDrawer, {d, player_id});

export default ({d}) => <a onClick={() => openStats(d)}>Player Statistics</a>;